import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as jwtService from '../../../services/jwt/jwtService';
import { GOOGLE_CLIENT_ID } from '../../../config_module';

class LoginGoogleButtonWeb extends React.Component {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onFailure: PropTypes.func.isRequired
  };

  componentDidMount() {
    window.onGoogleLibraryLoad = () => {
      let autoSelect = false;
      if (window.location.search) {
        autoSelect = window.location.search.includes('ssoWith=google');
      }

      google.accounts.id.initialize({
        auto_select: autoSelect,
        client_id: GOOGLE_CLIENT_ID,
        callback: this.handleCallbackResponse(this.props.onSuccess)
      });

      google.accounts.id.prompt();

      google.accounts.id.renderButton(document.getElementById('google-auth-div'), {
        theme: 'filled_black',
        size: 'large'
      });
    };
  }

  handleCallbackResponse(onSuccess) {
    return response => {
      const profileInfo = jwtService.decode(response.credential);
      onSuccess({ accessToken: response.credential, ...profileInfo });
    };
  }

  render() {
    return <div id="google-auth-div"></div>;
  }
}

export default connect()(LoginGoogleButtonWeb);
